import { defineMessages } from '@formatjs/intl';

const messages = defineMessages({
	signupFormHeadingNoDiscount: {
		id: 'monthly.discount.signup.title.2.noDiscount',
		defaultMessage: 'Sleep better and stress less, one month at a time',
		description: 'The title for the Calm signup component',
	},
	signupFormHeading: {
		id: 'monthly.discount.signup.title.2',
		defaultMessage: 'Try Calm Premium one month at a time for {percentOff}% off!',
		description: 'The title for the Calm signup component with a perceent off discount',
	},
	loginFormHeading: {
		id: 'monthly.discount.login.title',
		defaultMessage: 'Log into your Calm account',
		description: 'The title for the Calm login component',
	},
	accountValuePropHeader: {
		id: 'monthly.discount.account.valueproplist.header',
		defaultMessage: 'Rest, relief and growth is within reach',
		description: 'Value props of calm with 40% off Calm Premium',
	},
	terms: {
		id: 'monthly.discount.payment.terms.short2',
		defaultMessage:
			'This monthly membership gives you unlimited access to Calm’s entire library of content. You will be charged {price} for a 1 month subscription that will renew at {originalPrice}, billed monthly.',
		description: 'A line to inform the user of the terms of their trial',
	},
	offerTerms: {
		id: 'purchaseTerms.noTrialTermsEligibility2.monthly',
		defaultMessage:
			'By clicking "Get Calm Premium", you agree to be automatically billed for Calm Premium at {price} for a 1 month subscription that will renew at {originalPrice}, billed monthly. <cancelAnytimeLink>Cancel anytime</cancelAnytimeLink>.',
		description: 'Terms for if user is not eligible for trial',
	},
});

export default messages;
